import { OnInit, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
declare let LimelightPlayerUtil: any;
@Component({
    selector: 'demo-video',
    template: '<div id="limelight_player_613347"></div>'
})
export class DemoVideoComponent implements OnInit {
    constructor(
        private route: ActivatedRoute) {

    }
    ngOnInit() {
        this.rendervideo();
    }

    rendervideo() {
        if (LimelightPlayerUtil) {
            LimelightPlayerUtil.embed({
                'height': 382, 'width': 679,
                'mediaId': 'dd96bcfeb49d491cb39b284496d9d916', 'playerId': 'limelight_player_613347', 'playerForm': '874df3accc1a478c9c034333b7d3f652'
            });
        }
    }

}
